import axios from "axios";
import {setAuthHeader} from "./setAuthHeader"
import {requestAccessToken} from "./googleDriveTokenManager"

const msGraphToken="fhg48_UfGhra8_ph"

async function getValidToken() {
  try {
    return await requestAccessToken();
  } catch {
    return localStorage.getItem("google_drive_token");
  }
}

export const setAuthHeaderForGoogleDrive = async () => {
  const googleEmail = localStorage.getItem("google_email");
  const googleToken = await getValidToken();
  return googleToken;
};

export const apiGoogleListFolderContents = async (parentFolderId) => {
  const token = await getValidToken();
  try {
    const response = await axios.get(
      `https://www.googleapis.com/drive/v3/files`,
      {
        params: {
          q: `'${parentFolderId}' in parents and trashed=false`,
          fields: 'files(id,name,webViewLink,mimeType,size,thumbnailLink)',
          pageSize: 100
        },
        headers: { Authorization: 'Bearer ' + token }
      }
    );
    return { data: { value: response.data.files } };
  } catch (err) {
    console.error(err);
    return { data: { value: [] } };
  }
};

export const apiGoogleCreateShareLink = async (fileId) => {
  const token = await getValidToken();
  try {
    await axios.post(
      `https://www.googleapis.com/drive/v3/files/${fileId}/permissions`,
      { role: 'reader', type: 'anyone' },
      { headers: { Authorization: 'Bearer ' + token } }
    );
    const response = await axios.get(
      `https://www.googleapis.com/drive/v3/files/${fileId}`,
      {
        params: { fields: 'webViewLink,id,name' },
        headers: { Authorization: 'Bearer ' + token }
      }
    );
    return { data: { link: { webUrl: response.data.webViewLink } } };
  } catch (err) {
    console.error("Error creating Google share link:", err);
    return { data: { link: { webUrl: `https://drive.google.com/file/d/${fileId}/view` } } };
  }
};

export const apiGoogleCreateEcosShareLink = async (fileId) => {
  const token = await getValidToken();
  try {
    await axios.post(
      `https://www.googleapis.com/drive/v3/files/${fileId}/permissions`,
      { role: 'writer', type: 'anyone' },
      { headers: { Authorization: 'Bearer ' + token } }
    );
    const response = await axios.get(
      `https://www.googleapis.com/drive/v3/files/${fileId}`,
      {
        params: { fields: 'webViewLink,id,name' },
        headers: { Authorization: 'Bearer ' + token }
      }
    );
    return { data: { link: { webUrl: response.data.webViewLink } } };
  } catch (err) {
    return { data: { link: { webUrl: `https://drive.google.com/file/d/${fileId}/view` } } };
  }
};

export const apiGoogleDeleteFile = async (fileId) => {
  if (!fileId) {
    console.warn("apiGoogleDeleteFile called with no fileId");
    return false;
  }
  const token = await getValidToken();
  try {
    await axios.delete(
      `https://www.googleapis.com/drive/v3/files/${fileId}`,
      { headers: { Authorization: 'Bearer ' + token } }
    );
    return true;
  } catch (err) {
    console.error("Error deleting Google Drive file:", err);
    return false;
  }
};

export const apiGoogleCreateFolder = async (data) => {
  const token = await getValidToken();
  let sysToken = localStorage.getItem("comis-app-token");
  setAuthHeader(sysToken);
  return axios.post("/googleDrive/createFolder", { ...data, token });
};

export const apiGoogleSearchFileByName = async (fileName, parentFolderId) => {
  const token = await getValidToken();
  try {
    const response = await axios.get(
      `https://www.googleapis.com/drive/v3/files`,
      {
        params: {
          q: `name='${fileName}' and '${parentFolderId}' in parents and trashed=false`,
          fields: 'files(id,name,webViewLink,mimeType)'
        },
        headers: { Authorization: 'Bearer ' + token }
      }
    );
    return { data: { value: response.data.files } };
  } catch (err) {
    return { data: { value: [] } };
  }
};

export const apiGoogleResolvePath = async (path) => {
  const token = await getValidToken();
  if (!token) return null;
  try {
    const res = await axios.post("/googleDrive/resolvePath", { token, path });
    return res.data.folderId;
  } catch (err) {
    console.error("apiGoogleResolvePath error:", err);
    return null;
  }
};

export const apiGoogleDownloadFile = async (fileId) => {
  const token = await getValidToken();
  if (!token) return null;
  try {
    const response = await axios.get(
      `https://www.googleapis.com/drive/v3/files/${fileId}?alt=media`,
      {
        responseType: 'blob',
        headers: { Authorization: 'Bearer ' + token }
      }
    );
    return response.data;
  } catch (err) {
    console.error("apiGoogleDownloadFile error:", err);
    return null;
  }
};

export const apiGoogleGetFile = async (fileId) => {
  const token = await getValidToken();
  try {
    const response = await axios.get(
      `https://www.googleapis.com/drive/v3/files/${fileId}`,
      {
        params: { fields: 'id,name,webViewLink,mimeType,size,thumbnailLink' },
        headers: { Authorization: 'Bearer ' + token }
      }
    );
    return { data: response.data };
  } catch (err) {
    console.error(err);
    return null;
  }
};
